import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import { WaterSystemsActions } from '../../store/waterSystems'

interface WaterSystem {
  _id: string
  PWSID: string
  PWS_NAME: string
  PWS_TYPE_CODE: string
  POPULATION_SERVED_COUNT: number
  SERVICE_CONNECTIONS_COUNT: number
  ADMIN_NAME: string
  EMAIL_ADDR: string
  PHONE_NUMBER: string
  ADDRESS_LINE1: string
  ADDRESS_LINE2: string
  CITY_NAME: string
  ZIP_CODE: string
  COUNTRY_CODE: string
  STATE_CODE: string
  COORDINATES: {
    formatted_address: string
    location: {
      lat: number
      lng: number
    }
  }
  matchScore: number
  VIOLATIONS_COUNT: number
}

interface WaterSystemsResponse {
  waterSystems: WaterSystem[]
  totalResults: number
}

export const useUtilitySearch = () => {
  const dispatch = useDispatch<AppDispatch>()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [utilities, setUtilities] = useState<WaterSystem[]>([])

  const { formData } = useSelector((state: RootState) => state.waterTestForm)

  useEffect(() => {
    const fetchUtilities = async () => {
      if (!formData.city || !formData.state || !formData.zipCode || !formData.streetName1) {
        setUtilities([])
        return
      }

      try {
        setIsLoading(true)
        setError('')

        const resultAction = await dispatch(
          WaterSystemsActions.fetchPublicWaterSystemsByAddressComponentAsync({
            city: formData.city,
            state: formData.state,
            zipCode: formData.zipCode,
            address1: formData.streetName1,
          })
        )
        if (WaterSystemsActions.fetchPublicWaterSystemsByAddressComponentAsync.fulfilled.match(resultAction)) {
          const response = resultAction.payload as WaterSystemsResponse
          setUtilities(response.waterSystems)
        } else {
          setError('Failed to fetch utilities')
          setUtilities([])
        }
      } catch (error) {
        console.error('Error fetching utilities:', error)
        setError('Unable to fetch utilities')
        setUtilities([])
      } finally {
        setIsLoading(false)
      }
    }

    const timeoutId = setTimeout(fetchUtilities, 500)
    return () => clearTimeout(timeoutId)
  }, [dispatch, formData.city, formData.state, formData.zipCode, formData.streetName1])

  return {
    isLoading,
    error,
    utilities,
  }
} 